import {ActiveRecord} from "./ActiveRecord";
import config from 'config';
import {LiveImageDTO, LiveImage} from "./image";
import {UserDTO} from './manager';
import {Product, ProductDto} from './product'

export const PROMOTION_TYPE_STANDART = 'standard';
export const PROMOTION_TYPE_VIP = 'vip';

export interface PromotionDTO {
  id?: string;
  product_id?: string;
  product?: ProductDto;
  title: string;
  description: string;
  short_content: string;
  image_url: LiveImageDTO;
  promotion_type: string;
  created_at: number;
  created_by: UserDTO;
  published_at: number;
  expire_at: number;
  published: boolean;
}

export class Promotion extends ActiveRecord {
  title: string;
  product: Product;
  description: string;
  short_content: string;
  createdBy: UserDTO;
  createDate: Date;
  expiredDate: Date;
  publishedDate: Date;
  published: boolean;
  image: LiveImage;
  promotionType: string = PROMOTION_TYPE_VIP;

  public static path = `${config.backOfficeBasePath}/promotions`;

  get vip(): boolean {
    return this.promotionType === PROMOTION_TYPE_VIP;
  }

  static mapRecords(data: PromotionDTO[]) {
    return data.map((item) => Object.assign(new Promotion({}), this.parseData(item)));
  }

  static parseData(data: PromotionDTO) {
    let res: any = {};

    res.id = data.id;
    res.title = data.title;
    res.product = new Product(data.product);
    if (data.image_url) {
      res.image = new LiveImage(Object.assign(new LiveImageDTO(), data.image_url));
    }
    res.createdBy = data.created_by;
    res.createDate = new Date(data.created_at);
    res.expiredDate =  data.expire_at ? new Date(data.expire_at) : null;
    res.publishedDate = data.published_at ? new Date(data.published_at) : null;
    res.published = data.published;
    res.description = data.description;
    res.short_content = data.short_content;
    res.promotionType = data.promotion_type;

    return res;
  }

  _parseData(data) {
    return Promotion.parseData(data);
  }

  prepareForSave(data: any) {
    data = Object.assign({}, this, data);

    return {
      title: data.title,
      description: data.description,
      short_content: data.short_content,
      product_id: data.product.id,
      promotion_type: data.vip ? PROMOTION_TYPE_VIP : PROMOTION_TYPE_STANDART,
      expire_at: data.expiredDate ? data.expiredDate.getTime() : null,
    }
  }

  async publish() {
    let response = await this._networkLayer.postJson(this._prepareUrl(this.id) + '/publish');

    let data = await response.json();

    this._extendData(data);

    return this;
  }

  protected async _updateRecord(dataForSave) {
    return await this._networkLayer.patchJSON(this._prepareUrl(this._id), dataForSave);
  }

}



// WEBPACK FOOTER //
// ./src/api/promotion.ts